<template>
  <wh-popup
    v-model="myVisible"
    :ref-form="$refs.ProcessPopup"
    title="编辑原料溯源"
    @close="hidePopup"
    @submit="submit"
  >
    <van-form ref="pickInfoForm" class="form" label-width="60px">
      <div class="form-box">
        <unit-title style="margin: 12px 12px" title="产品信息" />
        <div class="product-image">
          <wh-upload v-model="productPic" :max-count="1" />
        </div>
        <van-field v-model="form.productName" disabled label="名称" />
        <van-field
          :label="`${currentPlantTypeData.plantType}标准`"
          name="plantStandard"
        >
          <template #input>
            <van-radio-group
              v-model="form.productPlantStandard"
              class="radio-group"
              direction="horizontal"
            >
              <van-radio v-for="(item,key) in plantStandard" :key="key" :name="item.value" class="radio-group-item">
                {{ item.label }}
              </van-radio>
            </van-radio-group>
          </template>
        </van-field>
        <van-field :value="form.productPickTime" disabled label="采收时间" />
      </div>
      <div class="list">
        <unit-title style="margin: 0 12px" title="种植环节" />
        <div
          v-for="(item, key) in form.farmWorkJSON"
          :key="key"
          :class="{selected: item.selected, 'not-change': item.notChange}"
          class="list-item"
          @click="toggleSelect(item)"
        >
          <van-icon class="checked-icon" name="checked" />
          <div class="card">
            <template v-if="item.notChange">
              <div class="name">
                {{ item.name }}
              </div>
              <div class="bottom-content">
                <div class="time">
                  {{ formatTime(item.startDate, 'YYYY-MM-DD') }}
                </div>
              </div>
            </template>
            <template v-else>
              <div class="name">
                {{ item.farmWork }}
              </div>
              <div class="bottom-content">
                <div class="time">
                  {{ formatTime(item.beginTime, 'YYYY-MM-DD') }}
                </div>
                <div class="operator">
                  操作人：{{ item.operator }}
                </div>
              </div>
            </template>
          </div>
        </div>
      </div>
    </van-form>
  </wh-popup>
</template>

<script>
import { formPopup } from '@/utils/mixins/formPopup'
import WhPopup from '@/components/public/WhPopup/WhPopup'
import { initObjData } from '@/utils/tool'
import api from '@/api'
import { formatTime } from '@/utils/convert/convertTime'
import { UPLOAD_CONFIG } from '@/constant/config'
import { PLANT_STANDARD, PLANT_TYPE_DATE } from '@/constant/common'
import WhUpload from '@/components/public/WhUpload/WhUpload'
import UnitTitle from '@/views/productManage/TraceSource/components/UnitTitle'

export default {
  name: 'PackingTraceabilityEdit',
  components: {
    WhPopup, WhUpload, UnitTitle
  },
  mixins: [formPopup],
  props: {
    // 通过绑定 route.query 传递
    traceCode: {
      type: String,
      default: undefined
    }
  },
  data() {
    return {
      plantStandard: { ...PLANT_STANDARD },
      currentPlantTypeData: {},
      form: {
        id: undefined,
        traceCode: undefined,
        productName: '',
        productCropType: '',
        productPlantStandard: undefined,
        productPickTime: undefined,
        productPic: '',
        farmWorkJSON: [
          {
            farmWork: undefined,
            agriculturalName: undefined,
            agriculturalDosage: undefined,
            staffName: undefined
          }
        ],
        inspectCertInfoJSON: [],
        cameraUrl: undefined,
        sensorId: undefined,
        landId: '',
        land: {},
        company: {},
        companyId: undefined,
        logisticCompany: undefined,
        logisticCode: undefined
      }
    }
  },
  computed: {
    productPic: {
      get() {
        if (this.form.productPic) {
          return [
            {
              url: this.form.productPic
            }
          ]
        } else {
          return []
        }
      },
      set(val) {
        if (val && val.length) {
          this.form.productPic = `${UPLOAD_CONFIG.fetchUrl}${val[0].key}`
        } else {
          this.form.productPic = ''
        }
      }
    }
  },
  watch: {
    myVisible(nv, ov) {
      if (nv) {
        this.handleOpen()
      }
    }
  },
  methods: {
    async handleOpen() {
      await api.getControlProductTrace({ traceCode: this.traceCode }).then(({ data }) => {
        let inspectCertInfoJSON = data.inspectCertInfoJSON
        if (!inspectCertInfoJSON || !inspectCertInfoJSON.length) {
          inspectCertInfoJSON = data.controlInspectReport || []
        }
        initObjData(this.form, {
          ...data,
          inspectCertInfoJSON,
          productPickTime: formatTime(data.productPickTime),
          companyId: this.$store.getters.companyId
        })
        if (this.form.productCropType) {
          this.currentPlantTypeData = { plantType: PLANT_TYPE_DATE[this.form.productCropType].plantType }
        }
      })
    },
    submit() {
      this.form.traceCode = this.traceCode
      const inspectCertInfoJSON = this.form.inspectCertInfoJSON.filter(item => item.reportName).map(listItem => {
        listItem.pic = listItem.pic.map(item => { // 对图片相关数据进行处理
          let url = item.url
          let urlThumbnail = item.urlThumbnail
          if (/^blob:http:/.test(item.url)) {
            url = `${UPLOAD_CONFIG.fetchUrl}${item.key}` // 转换为线上地址存储
            urlThumbnail = `${UPLOAD_CONFIG.fetchUrl}${item.key}?imageView2/1/w/100/h/100/q/75|imageslim`
          }
          return {
            key: item.key,
            url: url,
            urlThumbnail,
            name: item.name
          }
        })
        return listItem
      })
      api.updateControlProductTrace({
        ...this.form,
        inspectCertInfoJSON: inspectCertInfoJSON,
        farmWorkJSON: this.form.farmWorkJSON
      }).then(() => {
        this.$toast.success('更新原料溯源成功')
        this.hidePopup()
      })
    },
    formatTime,
    toggleSelect(item) {
      if (!item.notChange) {
        this.$set(item, 'selected', !item.selected)
      }
    }
  }
}
</script>

<style lang="less" scoped>
.product-image {
  display: flex;
  justify-content: center;
  margin-top: 12px;
}
.submit-box {
  @height: 40px;
  height: @height; //用于占位
  display: block;
  width: 100%;
  .submit {
    height: @height - 20px;
    width: 200px;
    position: fixed;
    letter-spacing: 0.2em;
    bottom: 0;
    left: 0;
    right: 0;
    margin: 10px auto;

    padding: 20px 0 20px 0;
  }
}

.list {
  margin-top: 20px;
  .list-item {
    padding: 10px 30px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    &.not-change {
      pointer-events: none;
      .checked-icon {
        color: @primary-color;
      }
      .card {
        box-shadow: none;
      }
    }
    &.selected {
      .checked-icon {
        color: @primary-color;
      }
    }
    .checked-icon {
      text-align: center;
      font-size: 20px;
      color: #ccc;
    }
    .card {
      border-radius: 4px;
      padding: 14px 10px;
      width: 86%;
      box-shadow: 0 0 10px 0 #ccc;
      .name {
        font-size: 20px;
        font-weight: bold;
      }
      .bottom-content {
        display: flex;
        justify-content: space-between;
        .time {
          padding: 1px 4px;
          background-image: linear-gradient(to right, #23bf7f, #51dc86);
          font-size: 14px;
          color: #fff;
          border-radius: 4px;
          margin-top: 10px;
        }
        .operator {
          font-size: 12px;
        }
      }
    }
  }
}
</style>
